import { IconTrashX } from "@tabler/icons-react";
import Badge from "components/Badge";
import { observer } from "mobx-react-lite";
import { globalStore } from "store/GlobalStore";
import { productSearchStore as store } from "../ProductSearchStore";

export default observer(function SelectedFilters() {
  const isEng = globalStore.currentLanguage === "en";

  const onRemoveFilter = (categoryId: string | number | undefined) => {
    const filteredItems = store.selectedFilters.filter(
      (rec) => rec.category.id !== categoryId
    );
    store.setSelectedFilters(filteredItems);
    store.searchProducts();
  };

  const onRemoveAllFilters = () => {
    store.setSelectedFilters([]);
    store.searchProducts();
  };

  return (
    <div className="flex gap-4 mb-3 flex-wrap items-center">
      {store.selectedFilters.map((rec) => (
        <Badge
          closable
          key={rec.category.id}
          type="auto"
          className="!min-h-6 !h-auto !py-1 !mb-0 font-medium !whitespace-normal"
          onClose={() => onRemoveFilter(rec.category.id)}
        >
          <div className="w-full">
            <span className="font-bold">
              {isEng
                ? rec.category.name
                : rec.category.name_de ?? rec.category.name}
              :
            </span>
            <span className="mx-1 break-words">
              {rec.items
                .map((item) => (isEng ? item.name : item.name_de ?? item.name))
                .join(", ")}
            </span>
          </div>
        </Badge>
      ))}
      {store.selectedFilters.length > 0 && (
        <IconTrashX
          className="text-gray-700 cursor-pointer"
          size={20}
          stroke={2}
          onClick={onRemoveAllFilters}
        />
      )}
    </div>
  );
});
